import { SourceDataItemGroupType } from "@/api/dtos";

const sourceDataItemGroupTypeToText = (groupType?: SourceDataItemGroupType) => {
    switch (groupType) {
        case SourceDataItemGroupType.Grid:
            return 'Grid';
        case SourceDataItemGroupType.Group:
        default:
            return 'Group'
    }
}

export default sourceDataItemGroupTypeToText;